import { MouseEventHandler, ReactElement } from "react";

export function Button(props: {
  onClick: MouseEventHandler<HTMLButtonElement>;
  className: string;
  disabled?: boolean;
  children: string | ReactElement | ReactElement[];
}): ReactElement {
  const { onClick, className, disabled, children } = props;

  return (
    <button
      className={`p-1 w-32 text-white ${className} focus:ring-0`}
      type="button"
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  );
}
